import React from 'react'
import cx from 'classnames'
import './style'

const Background = () => (
    <div
        {...{
            className: cx(
                'Background',
            ),
        }}
    />
)

export default Background
